import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/styles/app.css';
import './assets/styles/fonts.css';
import './assets/styles/custom.css';
import '@utahdts/utah-design-system-header/css'; // New Utah Header CSS
import { setUtahHeaderSettings } from '@utahdts/utah-design-system-header'; // New Utah Header import JS
import EmployeeEmployeePaySearch from './components/EmployeeEmployeePaySearch';
import HeaderComponent from './components/HeaderComponent';
import HomePage from './components/HomePage';
import HigherEducation from './components/HigherEducation';
import EmployeePages from './components/EmployeePages';
import EntityPages from './components/EntityPages';
import JobTitleCompensation from './components/JobTitleCompensation';
import PublicEducation from './components/PublicEducation';
import HigherEducationSubpage from './components/HigherEducationSubpage';
import StateOfUtah from './components/StateOfUtah';
import HealthCare from './components/HealthCare';
import PopularTools from './components/PopularTools';
import AllPages from './components/AllPages';
import NotFound from './components/NotFound';
import RedirectComponent from 'components/RedirectComponent';
import RedirectNoParams from 'components/RedirectNoParams';
import EntityOverviewDashboard from 'components/EntityOverviewDashboard';
import EmployeeHighestPaidEmployee from 'components/EmployeeHighestPaidEmployee';
import EmployeesHighestPaidJobs from 'components/EmployeesHighestPaidJobs';
// import SpecialEventPopup from "./components/SpecialEventPopup";
import EmployeesMostCommonJobs from 'components/EmployeesMostCommonJobs';
import EmployeesJobTitleWageTrends from 'components/EmployeesJobTitleWageTrends';
import EntityVendorPaymentSearch from 'components/EntityVendorPaymentSearch';
import SearchReports from 'components/SearchReports';
import EntityCompensationDownloader from 'components/EntityCompensationDownloader';
import EmployeesLocalGovernmentJobs from 'components/EmployeesLocalGovernmentJobs';
import EmployeesJobTitleSearch from 'components/EmployeesJobTitleSearch';
import EntityHighestPaidVendors from 'components/EntityHighestPaidVendors';
import EntityCompareTwoEntities from 'components/EntityCompareTwoEntities';
import TransparentUtahHelp from 'components/TransparentUtahHelp';
import EntityFiscalDistressDashboard from 'components/EntityFiscalDistressDashboard';

const notReadyForProduction = () => {
  const host = window.location.hostname;
  return host.includes("staging") || host.includes("localhost") || host.includes("ntgenix") || host.includes("mstillman-dev")
}

const App = () => {
  return (
    <div>
      <HeaderComponent /> {/* handles header/navbar hide/show on scroll */}
      <BrowserRouter>
      {/* render popup once globally (no config required here) */}
        {/* <SpecialEventPopup /> */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="employees/employee-search" element={<EmployeeEmployeePaySearch />} />
          <Route path="/employees" element={<EmployeePages />} />
          <Route path="/entities" element={<EntityPages />} />
          <Route path="/job-title-compensation" element={<JobTitleCompensation />} />
          <Route path="/higher-education" element={<HigherEducationSubpage />} />
          {/* <Route path="/super-user" element={<SuperUserPages />} /> */}
          <Route path="/public-education" element={<PublicEducation />} />
          <Route path="/state-of-utah" element={<StateOfUtah />} />
          <Route path="/healthcare" element={<HealthCare />} />
          <Route path="/popular-tools" element={<PopularTools />} />
          <Route path="/all" element={<AllPages />} />
          <Route path="/state_rvex.php" element={<RedirectNoParams/>} />
          <Route path="/batch_summary.php" element={<RedirectComponent />} />
          <Route path="/higher-education/higher-education-expenditure" element={<HigherEducation />} />
          <Route path="/entities/entity-overview-dashboard" element={<EntityOverviewDashboard/>}/> 
          <Route path="/employees/highest-paid-jobs" element={<EmployeesHighestPaidJobs />}/>
          <Route path="/employees/highest-paid-employees" element={<EmployeeHighestPaidEmployee/>}/>
          <Route path="/employees/most-common-jobs" element={<EmployeesMostCommonJobs/>}/>
          <Route path="/entities/vendor-payments-search" element={<EntityVendorPaymentSearch/>}/>
          <Route path="/employees/job-title-wage-trends" element={<EmployeesJobTitleWageTrends/>}/>
          <Route path="/employees/local-government-jobs" element={<EmployeesLocalGovernmentJobs/>}/>
          <Route path="/employees/job-title-search" element={<EmployeesJobTitleSearch/>}/>
          <Route path="/entities/highest-paid-vendors" element={<EntityHighestPaidVendors/>}/>
          <Route path="/entities/compare-two-entities" element={<EntityCompareTwoEntities/>}/>
          <Route path="/entities/fiscal-distress-dashboard" element={<EntityFiscalDistressDashboard/>}/>
          <Route path="/entities/compensation-downloader" element={<EntityCompensationDownloader/>}/>
          <Route path="/help" element={<TransparentUtahHelp/>}/>
          {/* Routes for in progress pages that aren't ready for production will now go in the notReadyForProduction section below */}
          {notReadyForProduction() && (
            <>
              {/* Entity Compensation Downloader will remain in Not Ready For Production until the database issues get fixed */}
              <Route path="/entities/compensation-downloader" element={<EntityCompensationDownloader/>}/>
              <Route path="/search-reports" element={<SearchReports/>}/>
            </>
          )}
           {/* Below route must be the lowest route in list of active routes */}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;